import Cookies from 'js-cookie';
import i18n from "../i18n";
import { configuration } from './configuration';
import { JwtHelper } from '../utilities/jwt-helper';
import { store } from '../store/index';
import {
  TicketMessageDTO, WebChatDTO, WebChatSettingsDTO, WebChatUpdateRequest
} from '../models/chat.models';

const fetch = require('node-fetch');

class WebChatService {
  
  private jwtHelper: JwtHelper = new JwtHelper();

  constructor() {
  }

  async getSettings(): Promise<WebChatSettingsDTO> {
    this.log(`WebChatService.getSettings()`);

    return fetch(configuration.SERVICE_URL + '/chat/webchat/configuration', {
      method: "GET",
      mode: "cors",
      headers: {
            "Content-Type": "application/json"
        }
    })
    .then(async response => {
      if (!response.ok) {
          this.handleResponseError(response);
      }
      const jsonObject = await response.json();
      const settings = new WebChatSettingsDTO();
      
      return {...settings, ...jsonObject};
    })
    .catch(error => {
      this.handleError(error);
    });
  }

  getAccountContext(token: string): string | undefined {
    return this.jwtHelper.getTenantUid(token) || this.jwtHelper.getTenantGuid(token);
  }

  async getActiveChat(session: string | null | undefined): Promise<WebChatDTO> {
    this.log(`WebChatService.getActiveChat(${session})`);
    
    return fetch(configuration.SERVICE_URL + '/chat/webchat/active/' + (session != undefined ? session : ''), {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        if (!response.ok) {
          this.handleResponseError(response);
        }
        return response.json();
      })
      .catch(error => {
        Cookies.remove("wch_session");
        this.handleError(error);
      });
  }

  async sendMessage(webChatUpdateRequest: WebChatUpdateRequest): Promise<TicketMessageDTO> {
    this.log(`WebChatService.sendMessage(${JSON.stringify(webChatUpdateRequest)})`);
    
    return fetch(`${configuration.SERVICE_URL}/chat/webchat/responsemessage`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(webChatUpdateRequest)
    })
    .then(response => {
      if (!response.ok) {
        this.handleResponseError(response);
      }
      return response.json();
    })
    .catch(error => {
      this.handleError(error);
    });

  }

  async getChatBotMessage(webChatUpdateRequest: WebChatUpdateRequest): Promise<TicketMessageDTO> {
    let timeoutId: NodeJS.Timeout | null = null;

    // Promesa que dispara el "thinking" si pasa 1 segundo
    const thinkingPromise = new Promise<void>((resolve) => {
      timeoutId = setTimeout(() => {
        store.dispatch({ type: "SET_THINKING", payload: true });
        resolve();
      }, 1000);
    });

    try {
      const response = await fetch(
        `${configuration.SERVICE_URL}/chat/webchat/responsemessage-chatbot`,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(webChatUpdateRequest),
        }
      );

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (!response.ok) {
        this.handleResponseError(response);
      }

      const data: TicketMessageDTO = await response.json();

      // Si estaba en "thinking", lo pongo en false
      store.dispatch({ type: "SET_THINKING", payload: false });

      return data;
    } catch (error) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      this.handleError(error);
      throw error;
    }
  }

  async sendFile(file: any, path: string): Promise<any> {
    this.log(`WebChatService.sendFile()`);
    
    let token = Cookies.get('token') || Cookies.get('accessToken');
    const isCustomer = Cookies.get('token') != undefined;
    let authorizationContext = this.getAccountContext(token);
    const data = new FormData();
    data.append('file', file);
    data.append('startingPathName', path);
   
    return fetch(`${configuration.SERVICE_URL}${isCustomer ? "api/file/upload": "api/file/anonymous/upload"}`, {
      method: "POST",
      mode: "cors",
      headers: {
          "Account-Context": authorizationContext,
          "Authorization": `Bearer ${token}`
      },
      body: data
    })
    .then(response => {
      if (!response.ok) {
          this.handleResponseError(response);
      }
      return response.json();
    })
    .catch(error => {
      this.handleError(error);
    });
  }

  //async closeWebchat(webChatCloseRequest: WebChatCloseRequest): Promise<WebChatDTO> {
  //  this.log(`WebChatService.closeWebchat(${webChatCloseRequest})`);
    
  //  let token = Cookies.get('token') || Cookies.get('accessToken');
  //  let authorizationContext = this.getAccountContext(token);

  //  return fetch(`${configuration.SERVICE_URL}api/webchat/close`, {
  //    method: "POST",
  //    mode: "cors",
  //    headers: {
  //        "Content-Type": "application/json",
  //        "Account-Context": authorizationContext,
  //        "Authorization": `Bearer ${token}`
  //    },
  //    body: JSON.stringify(webChatCloseRequest)
  //  })
  //  .then(response => {
  //    if (!response.ok) {
  //        this.handleResponseError(response);
  //    }
  //    return response.json();
  //  })
  //  .catch(error => {
  //    this.handleError(error);
  //  });
  //}

  //private async getHubConnectionDetails(session: string): Promise<HubTicketConnectionDetails> {
  //  this.log(`WebChatService.getHubConnectionDetails(${session})`);
    
  //  let token = Cookies.get('token') || Cookies.get('accessToken');
  //  let authorizationContext = this.getAccountContext(token);

  //  const request = { userId: session };
  //  return fetch(`${configuration.SERVICE_URL}api/webchat/hub/details`, {
  //    method: "POST",
  //    mode: "cors",
  //    headers: {
  //        "Content-Type": "application/json",
  //        "Account-Context": authorizationContext,
  //        "Authorization": `Bearer ${token}`
  //    },
  //    body: JSON.stringify(request)
  //  })
  //  .then(response => {
  //    if (!response.ok) {
  //        this.handleResponseError(response);
  //    }
  //    return response.json();
  //  })
  //  .catch(error => {      
  //    this.handleError(error);
  //  });
  //}

  async unsubscribeFromMessageTicket(ticketId: number,  session: string): Promise<void> {
    //this.log(`WebChatService.unsubscribeFromMessageTicket(${ticketId}, ${session})`);
    //const request = { userId: session, eventId: `ReceiveTicketMessage-${ticketId}` };
    
    //let token = Cookies.get('token') || Cookies.get('accessToken');
    //let authorizationContext = this.getAccountContext(token);

    //return fetch(`${configuration.SERVICE_URL}api/webchat/hub/unsubscribe/helpdeskgroup`, {
    //  method: "POST",
    //  mode: "cors",
    //  headers: {
    //      "Content-Type": "application/json",
    //      "Account-Context": authorizationContext,
    //      "Authorization": `Bearer ${token}`
    //  },
    //  body: JSON.stringify(request)
    //})
    //.then(response => {
    //  if (!response.ok) {
    //      this.handleResponseError(response);
    //  }
    //})
    //.catch(error => {      
    //  this.handleError(error);
    //});
  }

  getTranslations(key: number, webChatSettings: WebChatSettingsDTO): string {
    
    if (key == 1 && webChatSettings.WelcomeTitle != null) {
      return webChatSettings.WelcomeTitle;
    }
    if (key == 2 && webChatSettings.WelcomeSubTitle != null) {
      return webChatSettings.WelcomeSubTitle;
    }
    if (key == 3 && webChatSettings.StartChatTitle != null) {
      return webChatSettings.StartChatTitle;
    }
    if (key == 4 && webChatSettings.StartChatSubTitle != null) {
      return webChatSettings.StartChatSubTitle;
    }
    return i18n.translate(key.toString());
  }

  handleResponseError(response) {
      throw new Error("HTTP error, status = " + response.status);
  }

  handleError(error) {
      this.log(error.message);
  }

  static toCamel(o) {
    var newO, origKey, newKey, value
    if (o instanceof Array) {
      return o.map(function(value) {
          if (typeof value === "object") {
            value = WebChatService.toCamel(value)
          }
          return value
      })
    } else {
      newO = {}
      for (origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString()
          value = o[origKey]
          if (value instanceof Array || (value !== null && value.constructor === Object)) {
            value = WebChatService.toCamel(value)
          }
          newO[newKey] = value
        }
      }
    }
    return newO
  }

  log(data: string): void {
    //console.log(data);
  }

  error(data: any): void {
    //console.error(data);
  }
}
export const webChatService = new WebChatService();
